import { Module, ActionContext } from 'vuex';
import { ajax } from '@/util/ajax';

const URL = {
  PAGE: '/dh-datamaint/knowledge/page',
  ADD: '/dh-datamaint/knowledge/add',
  DELETE: '/dh-datamaint/knowledge/delete',
  DETAIL: '/dh-datamaint/knowledge/getById',
  BASIC_DETAIL: '/dh-datamaint/knowledge/getBasicById',
  SPECIMEN_DETAIL: '/dh-datamaint/knowledge/specimen/getByKnowledgeId',
  SPECIMEN_SAVE: '/dh-datamaint/knowledge/specimen/save',
  FILE_DETAIL: '/dh-datamaint/knowledge/file/getByKnowledgeId',
  FILE_SAVE: '/dh-datamaint/knowledge/file/save',
  KEYWORD_DETAIL: '/dh-datamaint/knowledge/keyword/getByKnowledgeId',
  KEYWORD_SAVE: '/dh-datamaint/knowledge/keyword/save',
  QUESTION_DETAIL: '/dh-datamaint/knowledge/question/getByKnowledgeId',
  QUESTION_SAVE: '/dh-datamaint/knowledge/question/save',
  RELATION_TREE: '/dh-datamaint/knowledge/relation/tree',
  RELATION_DETAIL: '/dh-datamaint/knowledge/relation/list',
  RELATION_SAVE: '/dh-datamaint/knowledge/relation/save',
  STUDY_SKILL_DETAIL: '/dh-datamaint/knowledge/studySkill/getByKnowledgeId',
  STUDY_SKILL_SAVE: '/dh-datamaint/knowledge/studySkill/save',
  UPDATE: '/dh-datamaint/knowledge/update',
  MOVE: '/dh-datamaint/knowledge/move',
  MOVE_TO: '/dh-datamaint/knowledge/moveTo',

  IMPORT: '/dh-datamaint/knowledge/import',
  PAGE_IMPORT: '/dh-datamaint/knowledge/import/page'
};

class KnowledgePageModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getPage(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.PAGE, { params: payload.data });
    },

    async getDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.DETAIL, { params: payload.data });
    },

    async getBasicDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.BASIC_DETAIL, { params: payload.data });
    },

    async getSpecimenDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.SPECIMEN_DETAIL, { params: payload.data });
    },

    async getFileDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.FILE_DETAIL, { params: payload.data });
    },

    async getKeywordDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.KEYWORD_DETAIL, { params: payload.data });
    },

    async SaveKeyword(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.KEYWORD_SAVE, payload.data);
    },

    async getQuestionDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.QUESTION_DETAIL, { params: payload.data });
    },

    async getRelationTree(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.RELATION_TREE, { params: payload.data });
    },

    async getRelationList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.RELATION_DETAIL, { params: payload.data });
    },

    async getStudySkillDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.STUDY_SKILL_DETAIL, { params: payload.data });
    },

    async Add(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.ADD, payload.data);
    },

    async SaveSpecimen(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.SPECIMEN_SAVE, payload.data);
    },

    async SaveFile(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.FILE_SAVE, payload.data);
    },

    async SaveQuestion(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.QUESTION_SAVE, payload.data);
    },

    async SaveRelationList(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.RELATION_SAVE, payload.data);
    },

    async SaveStudySkill(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.STUDY_SKILL_SAVE, payload.data);
    },

    async Update(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.UPDATE, payload.data);
    },

    async Move(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.MOVE, payload.data);
    },

    async MoveTo(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.MOVE_TO, payload.data);
    },

    async Delete(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.DELETE, null, { params: payload.data });
    },


    async import(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.IMPORT, payload.data);
    },

    async getImRecPage(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.PAGE_IMPORT, { params: payload.data });
    }
  };
}

export const knowledgePageModule = new KnowledgePageModule();
